import { RoomSocketClient } from './roomSocketClient';
import { createLogger } from '@airhead-games/shared/utilities';
import { getRoomWebSocketUrl } from '@airhead-games/shared/utilities/getUrl';
const logger = createLogger('roomConnectionManager');
export class RoomConnectionManager {
  // Hazard: only our own disconnect() clears this, so a server-side close leaves
  // it stale and connectToRoom for the same room no-ops without creating a
  // socket. Clearing it on close is unsafe while the client self-reconnects on
  // its own backoff (both paths could open one). Derive from the client instead.
  private currentRoomCode: string | null = null;
  private wsClient: RoomSocketClient;

  constructor(wsClient: RoomSocketClient) {
    this.wsClient = wsClient;
  }

  /**
   * Connects to a WebSocket room if not already connected to it.
   * @param roomCode The room code to connect to.
   */
  public async connectToRoom(roomCode: string): Promise<void> {
    if (this.currentRoomCode === roomCode) {
      logger.debug(
        `Already connected to room ${roomCode}. Ignoring connect call.`
      );
      return;
    }

    if (this.currentRoomCode) {
      this.disconnect();
    }

    const url = getRoomWebSocketUrl(roomCode);
    logger.debug(`Connecting to websocket for room ${roomCode}...`);
    try {
      await this.wsClient.connect(url);
      this.currentRoomCode = roomCode;
    } catch (error) {
      logger.error(`Failed to connect to room ${roomCode}:`, error);
      throw error;
    }
  }

  /**
   * Disconnects from the current WebSocket room.
   */
  public disconnect(): void {
    if (!this.currentRoomCode) {
      logger.debug('No active connection to disconnect from. Ignoring.');
      return;
    }
    logger.debug(
      `Disconnecting from websocket for room ${this.currentRoomCode}...`
    );
    this.wsClient.disconnect();
    this.currentRoomCode = null;
  }
}
